<div class="filter-component">
  <div class="flex-center">
    <ion-searchbar
      class="j-search"
      clear-icon="null"
      placeholder="{{ 'common.filter' | translate }}"
      (ionChange)="search()"
      [(ngModel)]="filter.Search"
      search-icon="/assets/icon/searchbar.svg"></ion-searchbar>
  </div>

  <ion-list class="j-popover-content scroll">
    <ion-radio-group [(ngModel)]="category.id">
      <ion-item *ngFor="let ct of categories" class="item-popover-content flex-center" lines="none">
        <ion-label class="mt">{{ ct.name | i18n }}</ion-label>
        <ion-radio class="popover-radio" slot="start" [value]="ct.id" (click)="close(ct)"> </ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</div>
